document.addEventListener("DOMContentLoaded", function () {
  const contactFormWrap = document.querySelector(".contact-form-wrap");

  if (contactFormWrap) {
    const reasons = document.querySelectorAll(
      'input[type=radio][name="reason"]'
    );
    const mode = contactFormWrap.dataset.mode;

    for (const reason of reasons) {
      if (mode && mode === reason.value) {
        reason.checked = true;
      }

      reason.addEventListener("change", function (e) {
        const currentReason = e.target.value;
        displayContactFormFields(currentReason);
      });
    }

    if (mode) {
      displayContactFormFields(mode);
    }
  }
});

const displayContactFormFields = (mode) => {
  const fieldReason = document.getElementById("field_reason");
  const contactFormWrap = document.querySelector(".contact-form-wrap");
  const currentInput = fieldReason.querySelector(
    `input[type=radio][value="${mode}"]`
  );
  const formContainers = contactFormWrap.querySelectorAll(
    ".contact-form-holder"
  );
  const targetContainer = currentInput.dataset.id;
  const targetElement = document.getElementById(targetContainer);

  for (const el of formContainers) {
    el.style.display = "none";
  }

  targetElement.style.display = "block";
};
